import InteractionStudioCodes from '../../scripts/constants/interaction-studio-types.js';
import { getIdCode } from '../../scripts/utilities/interaction-studio-functions.js';
import { getLocationIso } from '../../scripts/utilities/interaction-studio-utilities.js';
import asyncActionTypes from '../actions/types.js';

const initialState = {
  actionLogin: false,
  activeRejectEvent: false,
  ancillariesIsList: {},
  ancillariesIsListTraking: {},
  ancillaryEventData: {},
  ancillaryPersonalitationList: { products: [] },
  ancillaryPersonalitationListTraking: {},
  dataLoginUser: {},
  items: [],
  lastViewAncillary: '',
  impressionTrack: false,
};

const InteractionStudio = (state = initialState, action) => {
  if (!window?.Evergage) {
    return { ...state };
  }

  switch (action.type) {
    case asyncActionTypes.LOGIN_VIEW:
      window.Evergage.sendEvent({
        action: 'Web - Vista Login',
      });

      return {
        ...state,
      };
    case asyncActionTypes.REGISTER:
      window.Evergage.sendEvent({
        action: 'Web - Registro',
        user: {
          attributes: {
            ...action.payload,
            'ffn_dp_id': action.payload?.['ffn_dp_id'],
          },
          id: action.payload?.emailAddress,
        },
      });

      return {
        ...state,
      };
    case asyncActionTypes.REGISTER_VIEW:
      window.Evergage.sendEvent({
        action: 'Web - Vista Registro',
      });

      return {
        ...state,
      };
    case asyncActionTypes.LOGIN_ACTION:
      window.Evergage.sendEvent({
        action: 'Web - Login',
        user: {
          attributes: {
            'emailAddress': action.payload.userEmailCp,
            'ffn_dp_id': action.payload.ffn_dp_id.toString(),
          },
          id: action.payload.userEmailCp,
        },
      });

      return {
        ...state,
        dataLoginUser: {
          'emailAddress': action?.payload?.userEmailCp,
          'ffn_dp_id': action?.payload?.ffn_dp_id.toString(),
        },
      };
    case asyncActionTypes.SEARCH_ITINERARY:
      window.Evergage.sendEvent({
        action: 'Web - Buscar Itinerario',
        user: {
          attributes: {
            pnrApellido: action.payload.pnrApellido,
          },
        },
      });

      return {
        ...state,
      };
    case asyncActionTypes.QUICK_VIEW_ITEM:
      const { id, description, title, subtitle, imageUrl, locale } = action.payload;
      const flagAncillary = ['BAG', 'UPG', '0MJ', 'PRI'];
      const descriptionAncillary = flagAncillary.includes(id) ? description : subtitle;
      const nameAcillary = flagAncillary.includes(id) ? `${title}|${subtitle}` : title;
      const imageIS = locale === 'es_MX' ? { imageUrl, url: imageUrl } : { url: imageUrl };
      window.Evergage.sendEvent({
        action: 'Web - Vista Rápida de Producto',
        source: {
          locale,
        },
        itemAction: window.Evergage.ItemAction.QuickViewItem,
        catalog: {
          Product: {
            _id: getIdCode(id),
            description: descriptionAncillary,
            name: nameAcillary,
            ...imageIS,
            relatedCatalogObjects: {
              Section: ['MYB'],
              ProductType: ['ancillary'],
            },
            sku: {
              _id: getIdCode(id),
            },
          },
        },
      });

      return {
        ...state,
        activeRejectEvent: true,
        lastViewAncillary: getIdCode(id),
      };
    case asyncActionTypes.STOP_VIEW_ITEM:
      window.Evergage.sendEvent({
        action: 'Web - Detener Vista Rápida de Producto',
        itemAction: window.Evergage.ItemAction.StopQuickViewItem,
      });

      return {
        ...state,
      };
    case asyncActionTypes.SESION_EXPIRE:
      window.Evergage.sendEvent({
        action: 'Web - Sesión Expirada',
      });

      return {
        ...state,
      };

    case asyncActionTypes.ADD_TO_CART: {
      const isCampaignActive = Boolean(state.ancillaryPersonalitationList?.campaign || state.ancillaryPersonalitationListTraking?.campaign);
      const isControlUser = state.ancillaryPersonalitationListTraking?.userGroup === 'Control';
      const campaignProductsArray = state.ancillaryPersonalitationList?.products?.filter(element => element?.id === action?.payload?.lineItem?._id);
      const isCampaignProduct = campaignProductsArray?.length > 0;
      const productID = action?.payload?.lineItem?._id;

      window.FS?.event('Add to Cart', {
        'campaign_active': isCampaignActive,
        'control_user': isControlUser,
        'is_campaign_product': isCampaignProduct,
        'type_event':'Add to Cart',
        'type_product': 'ancillary',
        'id_product': productID,
      });

      const queryParam = new URLSearchParams(window.location.search);
      const iniciativaParam = queryParam.get('Iniciativa');
      const typeParam = queryParam.get('type');
      let transformTypeParam = null;

      if (typeParam !== null) {
        transformTypeParam = typeParam === 'cbx' ? '029' : typeParam === 'bags' ? 'BAG' : typeParam.toUpperCase(); 
      }

      // Por lo menos exista el type en el productID porque vienen mas
      if (iniciativaParam !== null && iniciativaParam === 'CU5' && typeParam !== null && transformTypeParam !== null && transformTypeParam === productID) {
        window.FS?.event('Add to Cart MYB Reject', {
          'is_campaign_product': true,
          'type_event': 'add_cart',
          'type_product': 'ancillary',
          'id_product': transformTypeParam,
        });
      }

      if (action?.payload?.sendEvent) {
        window.Evergage.sendEvent({
          action: 'Web - Agregar al carrito',
          itemAction: window.Evergage.ItemAction.AddToCart,
          cart: {
            singleLine: {
              Product: action?.payload?.lineItem,
            },
          },
        });
      }

      return {
        ...state,
        items: [...state?.items || [], action?.payload?.lineItem],
      };
    }

    case asyncActionTypes.REMOVE_FROM_CART:
      let ancToRemove = [];

      ancToRemove = [...state.items].filter(e => {
        if (e?.sku?._id === action?.payload?.lineItem?.sku?._id) {
          return e?.price !== action?.payload?.lineItem?.price ||
            e?.quantity !== action?.payload?.lineItem?.quantity;
        }
        return e?.sku?._id !== action?.payload?.lineItem?.sku?._id;
      });

      if (action.payload.sendEvent) {
        window.Evergage.sendEvent({
          action: 'Web - Remover del carrito',
          itemAction: window.Evergage.ItemAction.RemoveFromCart,
          cart: {
            singleLine: {
              Product: action.payload.lineItem,
            },
          },
        });
      }

      return {
        ...state,
        items: ancToRemove,
      };
    case asyncActionTypes.UPDATE_CART:
      window.Evergage.sendEvent({
        action: 'Web - Actualizar al carrito',
        itemAction: window.Evergage.ItemAction.UpdateLineItem,
        cart: {
          singleLine: {
            Product: { ...action.payload },
          },
        },
      });
      return {
        ...state,
      };
    case asyncActionTypes.BOOKING_STEPFORM:
      window.Evergage.sendEvent({
        action: 'Web - BookingStepForm',
      });
      return {
        ...state,
      };
    case asyncActionTypes.PURCHASE: {
      const isCampaignActive = Boolean(state.ancillaryPersonalitationList?.campaign || state.ancillaryPersonalitationListTraking?.campaign);
      const isControlUser = state.ancillaryPersonalitationListTraking?.userGroup === 'Control';
      const isCampaignProduct = action?.payload?.lineItems?.some(element=>state.ancillaryPersonalitationList?.products?.includes(element));
      const productID = action?.payload?.lineItems?.map(element => element?._id).join('-');
      
      window.FS?.event('Purchase', {
        'campaign_active': isCampaignActive,
        'control_user': isControlUser,
        'is_campaign_product': isCampaignProduct,
        'type_event':'purchase',
        'type_product': 'ancillary',
        'id_product': productID,
      });

      const queryParam = new URLSearchParams(window.location.search);
      const iniciativaParam = queryParam.get('Iniciativa');
      const typeParam = queryParam.get('type');
      let transformTypeParam = null;

      if (typeParam !== null) {
        transformTypeParam = typeParam === 'cbx' ? '029' : typeParam === 'bags' ? 'BAG' : typeParam.toUpperCase(); 
      }

      // Por lo menos exista el type en el productID porque vienen mas
      if (iniciativaParam !== null && iniciativaParam === 'CU5' && typeParam !== null && transformTypeParam !== null && productID.includes(transformTypeParam)) {
        window.FS?.event('Purchase MYB Reject', {
          'is_campaign_product': true,
          'type_event':'purchase',
          'type_product': 'ancillary',
          'id_product': transformTypeParam,
        });
      }
      
      window.Evergage.sendEvent({
        itemAction: window.Evergage.ItemAction.Purchase,
        action: 'Web - Vista Confirmación de compra',
        order: {
          Product: {
            currency: action?.payload?.currency,
            lineItems: action?.payload?.lineItems,
            orderId: action?.payload?.orderId,
            totalValue: action?.payload?.totalValue,
          },
        },
        source: {
          locale: getLocationIso(window?.location?.pathname?.split('/')[2]),
        },
      });
      return {
        ...state,
        activeRejectEvent: false,
      };
    }
    case asyncActionTypes.VIEW_CART:
      window.Evergage.sendEvent({
        action: 'Web - Actualizar al carrito',
        itemAction: 'View Cart',
        cart: {
          complete: {
            Product: action.payload || [],
          },
        },
      });
      return {
        ...state,
      };

    case asyncActionTypes.ACTION_LOGIN:
      return {
        ...state,
        actionLogin: action.payload,
      };
    case InteractionStudioCodes.MYB_ANCILLARY_PERSONALIZATION:
      const isCampaignActive = Boolean(state.ancillaryPersonalitationList?.campaign || state.ancillaryPersonalitationListTraking?.campaign);
      const isControlUser = state.ancillaryPersonalitationListTraking?.userGroup === 'Control';
      window.FS?.event('User Group', {
        'campaign_active': isCampaignActive,
        'control_user': isControlUser,
      });
      return {
        ...state,
        ancillaryPersonalitationList: { ...action?.payload },
      };
    case InteractionStudioCodes.MYB_ANCILLARY_PERSONALIZATION_CONTROL:
      return {
        ...state,
        ancillaryPersonalitationListTraking: { ...action.payload },
      };
    case InteractionStudioCodes.TRAKING_IMPRESSION:
      const experienceId = action?.payload?.experienceId || '';
      const idProducts = action?.payload?.idProducts || [];
      const control = action?.payload?.control || false;

      const products = Array.isArray(idProducts) ? idProducts?.filter(e => e !== undefined && e !== null) : [];
      
      const campaignControl = Boolean(control);
      const stat = {
        experienceId,
        stat: 'Impression',
        control: campaignControl,
        ...(products?.length === 0 ? {} : {
          catalog: {
            Product: idProducts || [],
          },
        }),
      };

      if (!campaignControl) {
        window.Evergage.sendStat({ campaignStats: [stat] });
      }
      return {
        ...state,
        impressionTrack: true,
      };

    default:
      return state;
  }
};

export default InteractionStudio;
